module.exports = __webpack_public_path__ + "img/tiktok_logo@2x.e2f75149.png";